import React from 'react';
import GA from '../../GoogleAnalytics'
import { CommonView } from '../../Layouts/CommonView';
import './index.scss'

export const ApoyaMali = function () {
    return (
        <div>
            <GA.RouteTracker title={"Apoya al MALI"}/>
            <CommonView title="Apoya al MALI" content={
                <div>Hay muchas maneras en las que puedes formar parte de ARCHI. <br></br><br></br>
                Proporcionándonos información adicional que tengas sobre la imagen de la obra que encuentras. Busca la opción “¿Tienes más información?” que se encuentra al lado de cada imagen. <br></br><br></br> 
                Comprando una fotografía en alta resolución. Si bien el acceso a las imágenes en baja resolución es gratuito, el uso comercial de estas supone un cobro para darle sostenibilidad al archivo. 
                Invitamos a artistas, fotógrafos, archivos e instituciones a formar parte de esta iniciativa. <br></br><br></br>
                Uniéndote al archivo enviándonos imágenes que pueden contribuir a enriquecer ARCHI.</div>}
            />   
        </div>
    )
}